import { DataContext } from "@/types";
import { Data } from "../Data";
import { User } from "../users/User";

// @ts-expect-error - static get() intentionally overrides base class return type
export class ManagerSelectorList extends Data {
  employees: any;
  attributes: any;
  static instance: ManagerSelectorList | null = null;

  constructor(options: any) {
    super({
      api: "/Employee/SearchManager?searchText=" + options.search,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });
  }

  onDataReceived(data: any) {
    this.employees = [];
    data.employees.forEach((e: any, index: any) => {
      const manager: any = new User({ data: { id: index, ...e } });
      manager.jobId = e.jobId;
      manager.fullName = e.employeeFullName;
      if (manager.fullName === null) manager.fullName = "Vacancy";
      manager.jobTitle = e.jobDefinitionName;
      manager.reportsToEmployeeFullname = e.reportsToEmployeeFullname;
      manager.directReports = e.directReports;
      this.employees.push(manager);
    });
  }

  static getManagerSelectorList(
    context: DataContext,
    search: string
  ): Promise<ManagerSelectorList> {
    return new Promise((resolve, reject) => {
      if (ManagerSelectorList.instance && search === "") resolve(ManagerSelectorList.instance);
      else
        ManagerSelectorList.instance = new ManagerSelectorList({
          resolve,
          reject,
          search,
          context
        });
    });
  }

  static get(context: DataContext, search: string | null): Promise<ManagerSelectorList> {
    return ManagerSelectorList.getManagerSelectorList(context, search ?? "");
  }

  findMatch(attr: any) {
    return this.attributes.find((a: any) => a.name === attr);
  }
}
